<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="7"></ucMenu>
					<div class="right_con">
						<div class="setting_main" v-loading="is_loading">
							<p class="fb">地址管理</p>
							<!-- <div class="add_wrap">
								<div class="title_line">
									<p class="title"></i>发货地址</p>
								</div>
								<div class="addBank_mask" >
									<div class="addBank_main">
										<div class="label-input">
											<p  class="label_title cate-label">省市区</p>
												<el-cascader
													:placeholder="deliverAddressName"
											    v-model="deliverRegionId"
													:props="regionProps"
											    @change="deliverRegionChange"></el-cascader>
										</div>

									</div>
								</div>
							</div> -->
							<div class="add_wrap">
								<div class="title_line">
									<p class="title">退货地址</p>
								</div>
								<div class="addBank_mask" >
									<div class="addBank_main">
										<div class="label-input">
											<p  class="label_title cate-label">省市区</p>
												<el-cascader
													:placeholder="returnAddressName"
											    v-model="returnRegionId"
													:props="regionProps"
											    @change="returnRegionChange"></el-cascader>
										</div>
										<el-input v-model="form.return_address.detail" placeholder="输入详细地址" class="el_input el_in3">
											<p slot="prefix" class="txts">详细地址</p>
										</el-input>
										<el-input v-model="form.return_address.name" placeholder="输入收货人姓名" class="el_input el_in3">
											<p slot="prefix" class="txts">收货人</p>
										</el-input>
										<el-input v-model="form.return_address.phone" placeholder="输入收货人手机号" class="el_input el_in3">
											<p slot="prefix" class="txts">手机号</p>
										</el-input>
										<div class="btn_wrap">
											<p class="btn" @click="bindSubmit">保存</p>
										</div>
									</div>
								</div>
							</div>
						</div>


            <FreightTemplateComponent></FreightTemplateComponent>

					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>
	</div>
</template>

<script>
import { mapActions,mapState } from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import common from '../../assets/js/utils/common';
import {supplierRegionList} from "../../api/main/ucenter.js";
import FreightTemplateComponent from "./components/index/freight_template/index.vue"

export default {
	name: "ucenterAddress",
	data() {
		return {
			is_loading:false,
			regionProps:{
				value:'id',
				label:'name',
				lazy: true,
				lazyLoad (node, resolve) {
										var cate = node?node:{value:0,level:1};
										var param = {pid:cate.value,level:cate.level+1}
											supplierRegionList(param).then(res => {
											if(res.code == 200){
												let list = res.data
												// console.log('leaf_list:',list)
												const nodes = Array.from(list)
													.map(item => ({
														id: item.id,
														name: item.name,
														level: item.level,
														leaf: item.children_count>0?0:1,//0为有下级 1为没有
													}));
												// console.log(nodes)
												resolve(nodes);
											}
										})
									}
			},
			deliverRegionId:[],
			deliverAddressName: '',
			returnRegionId:[],
			returnAddressName:'',
			form:{
				deliver_address: {
					province_id:'',
					city_id:'',
					town_id:'',
					street_id:'',
				},
				return_address: {
					province_id:'',
					city_id:'',
					town_id:'',
					street_id:'',
					name: '',
					phone: '',
					detail: ''
				},
			}
		}
	},
	components:{
		myHead,myFoot,ucMenu, FreightTemplateComponent
	},

	created(){
		this.init()
	},
	methods: {
		...mapActions({
			getSupplierAddress:"ucenter/getSupplierAddress",
			opSupplierAddressEdit:"ucenter/opSupplierAddressEdit",
			getSupplierRegionList:"ucenter/getSupplierRegionList"
		}),
		deliverRegionChange(value) {
			var address = this.form.deliver_address
			address.province_id = value[0]?value[0]:0
			address.city_id = value[1]?value[1]:0
			address.town_id = value[2]?value[2]:0
			address.street_id = value[3]?value[3]:0
			this.form.deliver_address = address
		},
		returnRegionChange(value) {
			var address = this.form.return_address
			address.province_id = value[0]?value[0]:0
			address.city_id = value[1]?value[1]:0
			address.town_id = value[2]?value[2]:0
			address.street_id = value[3]?value[3]:0
			this.form.return_address = address
		},
		init(){//初始化
			this.is_loading = true
			this.getSupplierAddress({data:{},success:(res)=>{
				this.is_loading = false
				console.log('get supplier address:',res)
				if(res.code===200){
					// var region = this.tree(res.data.region_list)
					// region = this.clean(region)
					var deliver_address = res.data.deliver_address
					if(deliver_address.province_id){
						this.deliverRegionId[0] = parseInt(deliver_address.province_id)
						this.deliverRegionId[1] = parseInt(deliver_address.city_id)
						this.deliverRegionId[2] = parseInt(deliver_address.town_id)
						this.deliverRegionId[3] = parseInt(deliver_address.street_id)
						var arrDeliverName = []
						if(this.deliverRegionId[0]){
								arrDeliverName.push(deliver_address.province)
						}
						if(this.deliverRegionId[1]){
								arrDeliverName.push(deliver_address.city)
						}
						if(this.deliverRegionId[2]){
								arrDeliverName.push(deliver_address.town)
						}
						if(this.deliverRegionId[3]){
								arrDeliverName.push(deliver_address.street)
						}
						this.deliverAddressName = arrDeliverName.join(' / ')
						this.form.deliver_address = deliver_address
						console.log(this.deliverAddressName)
					}else{
						this.deliverAddressName = '请选择'
					}
					var return_address = res.data.return_address
					if(return_address.province_id){
						this.returnRegionId[0] = return_address.province_id
						this.returnRegionId[1] = return_address.city_id
						this.returnRegionId[2] = return_address.town_id
						this.returnRegionId[3] = return_address.street_id

						var arrReturnName = []
						if(this.returnRegionId[0]){
								arrReturnName.push(return_address.province)
						}
						if(this.returnRegionId[1]){
								arrReturnName.push(return_address.city)
						}
						if(this.returnRegionId[2]){
								arrReturnName.push(return_address.town)
						}
						if(this.returnRegionId[3]){
								arrReturnName.push(return_address.street)
						}
						this.returnAddressName = arrReturnName.join(' / ')
						this.form.return_address = return_address
					}else{
						this.returnAddressName = '请选择'
					}
					// this.regionList = region
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},

		tree(data, pid = '0', r = []) {
			data.forEach((el,index) => {
					el.children = el.children || [];
					if (pid == el.pid) {
							r.push(el);
							data.splice(index,1)
							this.tree(data, el.id, el.children);
					}
			});
			return r;
		},
		clean(data){
			data.forEach((el,index) => {
				if(el.children.length > 0){
					el.children = this.clean(el.children)
				}else{
					data[index].children = false
				}
			})
			return data
		},
		bindSubmit(){
			let form = this.form
			this.opSupplierAddressEdit({data:form,success:(res)=>{
				if(res.code===200){
					this.$message({message: res.msg,type: 'success',});
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		}
	}
}
</script>

<style>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.ucenter_main{padding: 30px 0 40px;display: flex;justify-content: space-between;flex: 1;}

.right_con{width: 980px;background: #fff;}
.setting_main{padding: 36px 40px;}
.setiting_wrap{padding-top: 20px;}
.setting_line{margin-top: 30px;display: flex;font-size: 14px;line-height: 1;}
.setting_line .txt{width: 115px;text-align: right;}
.setting_line .con{flex: 1;width: 0;margin-left: 30px;display: flex;align-items: center;}
.setting_line .con .iconfont{font-size: 16px;color: #666666;margin-left: 10px;cursor: pointer;}
.add_wrap{margin-top: 10px;padding-top: 20px;}
.add_wrap .title_line{display: flex;justify-content: space-between;align-items: center;}
.add_wrap .title_line .title{display: flex;align-items: center;}
.add_wrap .title_line .title .icon_ali{width: 20px;height: 20px;margin-right: 8px;}
.add_wrap .title_line .title .icon_bank{width: 22px;height: 14px;margin-right: 8px;}
.add_wrap .title_line .btn{width: 74px;height: 32px;box-sizing: border-box;border: 1px solid var(--red);display: flex;justify-content: center;align-items: center;cursor: pointer;color: var(--red);font-size: 14px;margin-right: 20px;}
.add_wrap .title_line .btn:hover{background: #faedee;}


.addBank_mask{width: 100%;height: 100%;}
.addBank_mask .addBank_main{width: 400px;box-sizing: border-box;padding: 0 0 20px;background: #fff;}
.addBank_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.addBank_main .title{margin: 0 24px;font-size: 20px;line-height: 1;display: flex;align-items: center;padding-bottom: 15px;}
.addBank_main .title .icon{width: 22px;height: 14px;margin-right: 8px;}
.addBank_main .btn_wrap{margin: 32px 0 0;display: flex;justify-content: space-between;}
.addBank_main .btn_wrap .btn{width: 160px;height: 40px;box-sizing: border-box;border-radius: 6px;display: flex;justify-content: center;align-items: center;font-size: 14px;cursor: pointer;}
.addBank_main .btn_wrap .btn:nth-child(1){border: 1px solid #dddddd;color: #333;}
.addBank_main .btn_wrap .btn:nth-child(1){background: #f0413e;color: #fff;}

.label-input{width: 400px;margin-top: 14px;position: relative;}
.label_title{width: 76px;height: 100%;font-size: 12px;color: #999;display: flex;align-items: center;}
.cate-label{position: absolute;left: 5px;z-index: 1;padding-left: 10px;}
</style>
<style>
.setting_main .el-input--prefix .el-input__inner, .setting_main .el-cascader .el-input .el-input__inner, .el-input--prefix .el-input__inner, .setting_main .el-cascader .el-input .el-input__inner{height: 38px !important;}
.setting_main .el-cascader{width: 400px !important;}
.setting_main .el-cascader .el-input .el-input__inner::placeholder{color: #606266;}
.setting_main .el_input{margin: 14px 0 0 !important;}
.setting_main .el-input--prefix .el-input__inner,.setting_main .el-cascader .el-input .el-input__inner{padding-left: 76px;height: 34px;line-height: 34px;}

.setting_main .el_input{display: flex;margin: 12px 0 0;width: initial;}
.setting_main .el_input .el-input__inner{height: 38px;line-height: 38px;padding-left: 58px;flex: 1;width: 0;}
.setting_main .el_input.el_sel .el-input__inner{width: 100%;}
.setting_main .el_input .el-input__inner:focus , .el-select .el-input.is-focus .el-input__inner{border-color: var(--red);}
.el-select-dropdown__item.selected{color: var(--red);}
.setting_main .el_input.el_in2 .el-input__inner{padding-left: 110px;}
.setting_main .el_input.el_in3 .el-input__inner{padding-left: 85px;}
.setting_main .el_input .el-input__prefix{line-height: 38px;}
.setting_main .el_input .el-input__prefix .icons{width: 38px;height: 36px;display: flex;justify-content: center;align-items: center;top: 1px;left: 2px;background: #f5f5f5;border-right: 1px solid #ddd;border-radius: 4px 0 0 4px;}
.setting_main .el_input .el-input__prefix .icons .iconfont{font-size: 20px;color: #cccccc;}
.setting_main .el_input .el-input__prefix .txts{width: 100%;height: 100%;display: flex;align-items: center;color: #999;padding-left: 10px;}
.setting_main .el_input .el-input__suffix{display: flex;}
.setting_main .el_input .el-input__suffix .el-input__suffix-inner{display: flex;align-items: center;line-height: 38px;}
.setting_main .el_input .el-input__suffix .el-input__suffix-inner .getcode{font-size: 14px;color: #333333;padding: 0 12px;border-left: 1px solid #ccc;line-height: 1;cursor: pointer;}
.el-descriptions :not(.is-bordered) .el-descriptions-item__cell{padding-bottom: 20px;}
.el-descriptions-item__label:not(.is-bordered-label){margin-right: 30px;}
.el-input--prefix .el-input__inner,.el-cascader .el-input .el-input__inner{padding-left: 76px;height: 34px;line-height: 34px;}
/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{border-color: var(--red);}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover{color: var(--red);}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: var(--red);}

.el-button:focus, .el-button:hover{border-color: var(--red);color: var(--red);background:#fff;}
.el-button--primary{background: var(--red) !important;color: #fff !important;border-color: #fff;}
.el-button--primary:focus, .el-button:hover{border-color: var(--red);}
.el-loading-spinner .el-loading-text{color:var(--red);}
.el-loading-spinner .path{stroke: var(--red);}
.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}
.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{color: var(--red);}
</style>
